import React from "react";

const ChatListFooter = ({ onDone, isLoading = false }) => (
  <div className="sticky bottom-[0px] top-0  flex items-center justify-center">
    <button
      className="btn btn-default bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0"
      onClick={onDone}
      disabled={isLoading}
    >
      {isLoading ? "Loading..." : "Done"}
    </button>
  </div>
);

export default ChatListFooter;
